import { AbstractControl, ValidatorFn } from '@angular/forms';

export function noIdfValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
        const idfRegExp: RegExp = /^\d{2,7}$/;
        const valid = idfRegExp.test(control.value);
        return valid ? {'noIdf': {value: control.value}} : null;
    }
}
